import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Footer.css';
import { FaFacebook, FaTwitter, FaInstagram, FaGithub, FaYoutube, FaEnvelope } from 'react-icons/fa';
import logo from '../header/worksuite-logo.png';

const Footer = ({ showSocialLinks = false }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSectionOnHome = (sectionId, e) => {
    if (e) {
      e.preventDefault();
    }
    
    // If we're not on the home page, navigate there first
    if (location.pathname !== '/home') {
      navigate('/home');
      // Wait for navigation and DOM update, then scroll to section
      // Use a recursive function to wait for the element to be available
      const attemptScroll = (attempts = 0) => {
        const element = document.getElementById(sectionId);
        if (element) {
          // Small delay to ensure page is fully rendered
          setTimeout(() => {
            element.scrollIntoView({ behavior: 'smooth' });
          }, 100);
        } else if (attempts < 10) {
          // Try again after a short delay (max 10 attempts = ~1 second)
          setTimeout(() => attemptScroll(attempts + 1), 100);
        }
      };
      setTimeout(() => attemptScroll(), 200);
    } else {
      // We're already on home page, just scroll to section
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-brand">
          <div className="logo">
            <img src={logo} alt="Worksuite Logo" className="logo-image" />
            <span className="app-name">PROJECTO FI</span>
          </div>
          <p className="brand-description">
            Streamline your workflow and boost productivity with Projecto FI's comprehensive project management solution.
          </p>
          {showSocialLinks && (
            <div className="social-links">
              <button type="button" aria-label="Facebook" className="social-link"><FaFacebook /></button>
              <button type="button" aria-label="Twitter" className="social-link"><FaTwitter /></button>
              <button type="button" aria-label="Instagram" className="social-link"><FaInstagram /></button>
              <button type="button" aria-label="Github" className="social-link"><FaGithub /></button>
              <button type="button" aria-label="Youtube" className="social-link"><FaYoutube /></button>
            </div>
          )}
        </div>

        <div className="footer-links">
          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li><a href="https://app.projectofi.com/signup">Get Started</a></li>
              <li><a href="#pricing" onClick={(e) => scrollToSectionOnHome('pricing', e)}>Pricing</a></li>
              <li><a href="https://app.projectofi.com/login">Login</a></li>
              <li><a href="https://jbmediallc.freshdesk.com/support/home" target="_blank" rel="noopener noreferrer">Support</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Company</h3>
            <ul>
              <li><a href="#about" onClick={(e) => scrollToSectionOnHome('about', e)}>About</a></li>
              <li><a href="#features" onClick={(e) => scrollToSectionOnHome('features', e)}>Features</a></li>
              <li><a href="#pricing" onClick={(e) => scrollToSectionOnHome('pricing', e)}>Pricing</a></li>
              <li><a href="#contact" onClick={(e) => scrollToSectionOnHome('contact', e)}>Contact</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Others</h3>
            <ul>
              <li><a href="https://app.projectofi.com/page/terms-of-use" target="_blank" rel="noopener noreferrer">Terms of Use</a></li>
              <li><a href="https://app.projectofi.com/page/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a></li>
              <li><button type="button" className="footer-link-button" onClick={() => {
                window.scrollTo(0, 0);
                navigate('/unsubscribe');
              }}>Unsubscribe</button></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Contact Info</h3>
            <ul className="contact-info">
              <li>
                <FaEnvelope />
                <a href="mailto:company@example.com">info@projectofi.com</a>
              </li>
              <li>
                <FaEnvelope />
                <a href="mailto:company@example.com">support@projectofi.com</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>Copyright © 2025. All Rights Reserved</p>
      </div>
    </footer>
  );
};

export default Footer;
